<template>
  <div class="welcome-content">
    <el-row>
      <el-col :span="16">
        <SpCardContent title="欢迎语设置">
          <el-form-item
            v-if="isShowType"
            style="margin-top: 20px"
            label="客户类型"
          >
            <el-radio-group v-model="form.target">
              <el-radio :label="2">
                非会员
              </el-radio>
              <el-radio :label="1">
                会员
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            v-if="showRadio"
            label="设置欢迎语："
          >
            <el-radio-group v-model="form.msg_setting_type">
              <el-radio :label="1">
                渠道欢迎语
              </el-radio>
              <el-radio :label="2">
                默认欢迎语
              </el-radio>
              <el-radio :label="3">
                不使用欢迎语
              </el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="(showRadio && form.msg_setting_type === 1) || !showRadio">
            <el-form-item
              v-if="showWelcome"
              :label="single ? '欢迎语：' : '欢迎语1：'"
            >
              <Card
                title=""
                :show-delete="false"
                @deleteCard="deleteWelcome1"
              >
                <!-- <Card
                  title="插入{用户昵称}"
                  :show-delete="attachments.length >= 1 "
                  @deleteCard="deleteWelcome1"
                  @haddleTitle="addTitle"
                > -->
                <el-input
                  slot="content"
                  v-model="form.text_msg"
                  type="textarea"
                  maxlength="600"
                  :show-word-limit="true"
                  placeholder="请输入回复内容"
                  class="welcome1-content-input"
                />
              </Card>
            </el-form-item>
            <template v-if="!single">
              <el-form-item
                v-if="attachments.length < miniLength"
                label=""
              >
                <el-button
                  type="text"
                  @click="addWelcome"
                >
                  <i class="el-icon-circle-plus" />
                  添加欢迎语
                </el-button>
              </el-form-item>
              <template>
                <el-form-item
                  v-for="(item, index) in attachments"
                  :key="index"
                  :label="'欢迎语' + (showWelcome ? index + 2 : index + 1) + ':'"
                >
                  <MessageContent
                    :content="item"
                    :show-delete="
                      (showWelcome && attachments.length <= 2) || attachments.length >= 2
                    "
                    @deleteCard="deleteCard(index)"
                    @updateCardType="(params) => updateCardType({ index, ...params })"
                  />
                </el-form-item>
              </template>
            </template>
          </template>
        </SpCardContent>
      </el-col>
      <el-col :span="8">
        <div
          v-if="(showRadio && form.msg_setting_type === 1) || !showRadio"
          class="side-iphone"
        >
          <div class="divider" />
          <SpCardContent title="样式预览">
            <IphoneContent :form="form" />
          </SpCardContent>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import IphoneContent from './tmps/iphoneContent'
import MessageContent from './tmps/messageContent'
import Card from './comps/card.vue'
const defaultCardData = [
  {
    msgtype: 'image',
    image: {
      pic_url: '',
      image_type: 'image/png'
    }
  },
  {
    msgtype: 'link',
    link: {
      title: '',
      picurl: '',
      desc: '',
      url: ''
    }
  },
  {
    msgtype: 'miniprogram',
    miniprogram: {
      title: '',
      img_url: '',
      page: '',
      image_type: 'image/png'
    }
  }
]
export default {
  name: 'SpWelcome',
  components: { IphoneContent, MessageContent, Card },
  props: {
    form: {
      type: Object,
      default: () => {
        return {}
      }
    },
    showRadio: {
      type: Boolean,
      default: false
    },
    miniLength: {
      type: Number, // 欢迎语2的最小长度
      default: 1
    },
    single: {
      type: Boolean, // 只展示欢迎语1
      default: false
    },
    isShowType: {
      type: Boolean, // 是否展示欢迎语类型radio框
      default: false
    }
  },
  data () {
    return {
      attachments: [],
      showWelcome: true
    }
  },
  computed: {},
  watch: {
    form (newVal) {
      console.log(newVal, '欢迎语组件的值')
      this.form = newVal
      this.attachments = newVal.attachments
    },
    attachments (newVal) {
      this.form.attachments = newVal
    }
  },
  methods: {
    addWelcome () {
      this.attachments.push({
        msgtype: 'image',
        image: {
          pic_url: '',
          image_type: 'image/png'
        }
      })
    },
    deleteCard (index) {
      this.attachments.splice(index, 1)
    },
    updateCardType ({ type, index }) {
      const cardData = JSON.parse(JSON.stringify(defaultCardData.find((v) => v.msgtype === type)))
      this.attachments.splice(index, 1, cardData)
    },

    // 删除欢迎语昵称
    deleteWelcome1 () {
      this.showWelcome = false
      this.form.text_msg = ''
    },
    // 插入用户昵称
    addTitle () {
      this.form.text_msg = this.form.text_msg.concat('用户昵称')
    }
  }
}
</script>

<style lang="scss" scoped>
.welcome1-content-input {
  ::v-deep {
    .el-textarea__inner {
      border: none;
      resize: none;
      height: 120px;
    }
  }
}
.welcome-content {
  ::v-deep {
    .el-card {
      border: none;
    }
    .box-card {
      margin-bottom: 0;
    }
  }
}
.side-iphone {
  display: flex;
  .divider {
    width: 1px;
    height: 480px;
    margin-top: 10px;
    background-color: #eeeeee;
  }
}
</style>
